import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "items", "empty", "handle"];

  connect() {
    // this.showEmptyMessage()
  }

  itemsTargetConnected() {
    $(this.itemsTargets).sortable({
      handle: '*[data-collection-target="handle"]',
      axis: "y",
      cursor: "move",
      update: function (_event, ui) {
        const position =
          ui.item.prevAll('*[data-collection-target="item"]').length + 1;
        const path = ui.item.data("collection-item-path");
        const attributeName = ui.item
          .find('*[data-collection-target="handle"]')
          .data("collection-sort-order-attribute");
        const data = { _method: "PUT" };
        data[attributeName] = position;
        $.post(path, data);
      },
    });
  }

  itemTargetConnected() {
    // this.showEmptyMessage()
  }

  itemTargetDisconnected() {
    // this.showEmptyMessage()
  }

  showEmptyMessage() {
    if (this.itemTargets.length === 0) {
      this.emptyTarget.classList.remove("hidden");
    } else {
      this.emptyTarget.classList.add("hidden");
    }
  }
}
